import { canvas } from "@instructure/ui";

const themeWithOverrides = {
  ...canvas,
  colors: {
    ...canvas.colors,
    backgroundWarning: "#CF4A00",
    borderWarning: "#CF4A00",
    textWarning: "#CF4A00",
  },
};

export { themeWithOverrides };
